import type { SmBettingPolicy } from "@bridge-applications/pb-types";

/** Unlocks govern the picker; affordability governs a retained selection. */
export function availableSpinBets(
    energy: string,
    policy?: SmBettingPolicy,
): number[] {
    if (!policy) return [1];
    const balance = BigInt(energy);
    const unlocked = policy.tiers
        .filter(
            (tier) =>
                tier.multiplier !== "1" &&
                balance >= BigInt(tier.minimumEnergy),
        )
        .map((tier) => Number(tier.multiplier));
    return [1, ...unlocked.slice(-(policy.maxVisibleOptions - 1))];
}

export function nextSpinBet(
    current: number,
    available: readonly number[],
): number {
    return available.find((multiplier) => multiplier > current) ?? 1;
}

/** Waits after settlement, compensating for network and reel time. */
export function autospinDelay(
    elapsedMs: number,
    animationMs: number,
    spinDelayMs = 0,
): number {
    return Math.max(
        1000 - (elapsedMs - animationMs),
        1000 - animationMs,
        spinDelayMs,
    );
}
